import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, Observable, of, forkJoin } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { debounceTime } from 'rxjs/operators';
import { CustoAdicional } from 'src/app/models/custo-adicional.model';
import { CustoAdicionalService } from 'src/app/services/custo-adicional.service';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { Misc } from '../util/misc';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { CustoAdicionalTipoService } from 'src/app/services/custo-adicional-tipo.service';
import { CustoAdicionalTipo } from 'src/app/models/custo-adicional-tipo.model';
import { MatDialog } from '@angular/material/dialog';
import { EditarCustoAdicionalEstimativaDialogComponent } from './editar-custo-adicional-estimativa-dialog/editar-custo-adicional-estimativa.component';
import * as constants from 'src/app/models/constants/constants';

@Component({
  selector: 'app-custo-adicional',
  templateUrl: './custo-adicional.component.html',
  styleUrls: ['./custo-adicional.component.scss']
})
export class CustoAdicionalComponent implements OnInit {
  public keyUp = new Subject<MouseEvent>();

  @Input() estimativaId: number;
  @Input() somenteLeitura: boolean;
  @Input() hiddenResume: boolean;
  @Input() resetFormSubject: Subject<boolean> = new Subject<boolean>();

  loading: boolean;

  displayedColumns: string[] = ['delete', 'editar', 'descricao', 'quantidade', 'valor', 'valorTotal'];
  dataSource = new MatTableDataSource<CustoAdicional>();
  custosAdicionais: Array<CustoAdicional>;

  totalValor = 0;

  basicForm: UntypedFormGroup;
  estimativaTipo: number;
  tipoDelivery: boolean;

  custoAdicionalTipoLista: CustoAdicionalTipo[];
  filtroDescricao: UntypedFormControl = new UntypedFormControl();
  custoAdicionalTipoFiltrados: Observable<Array<CustoAdicionalTipo>> = null;

  constructor(
    private fb: UntypedFormBuilder,
    private estimativaService: EstimativaService,
    private toastr: ToastrComponent,
    private custoAdicionalService: CustoAdicionalService,
    public misc: Misc,
    private custoAdicionalTipoService: CustoAdicionalTipoService,
    private dialog: MatDialog,
  ) {

    this.createForm();

    const subscription = this.keyUp.pipe(
      debounceTime(250)
    ).subscribe(result => {
      this.enterSave();
    });
  }

  ngOnInit() {

    this.loading = true;

    this.carregarTela();

    this.loading = false;

    this.estimativaService.getById(this.estimativaId).subscribe((estimativa: any) => {
      if (estimativa.statusId === constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
        this.somenteLeitura = true;
      }
    });
  }

  carregarTela() {
    this.estimativaService.getEstimativaTipo(this.estimativaId).subscribe((result: any) => {

      this.estimativaTipo = result.estimativaTipoId;
      if (this.estimativaTipo == 3) {
        this.somenteLeitura = false;
        this.tipoDelivery = true;
        this.hiddenResume;
      }

      this.custoAdicionalService.getByEstimativaId(this.estimativaId).subscribe(
        result => {
          this.custosAdicionais = result.items;
          this.dataSource = new MatTableDataSource<CustoAdicional>(this.custosAdicionais);

          this.calculaTotal();
        },
        error => {
          this.toastr.mostrarMensagem("erro", "Atenção!", "Ocorreu um erro recuperando a lista de custos adicionais.");
        }
      ).add(() => {
        this.loading = false;
      })
    })

    this.populaFiltroCustosAdicionaisTipo();
  }

  createForm() {
    this.basicForm = this.fb.group({
      tb_custo_adicional_tipo: null,
      idCustoAdicionalTipo: [null, [Validators.required]],
      quantidade: [null, [Validators.required]],
      valor: [null, [Validators.required]]
    });
  }

  enterClick(event: KeyboardEvent) {
    event.preventDefault();

    if (event.keyCode === 13) {
      this.enterSave();
    }
  }

  enterSave() {
    this.loading = true;

    const custoAdicional: CustoAdicional = this.basicForm.getRawValue();

    if (Number(custoAdicional.idCustoAdicionalTipo) <= 0) {
      this.toastr.mostrarMensagem('aviso', 'Atenção', 'Selecione uma descrição.');
      this.loading = false
      return;
    }

    if (Number(custoAdicional.quantidade) <= 0) {
      this.toastr.mostrarMensagem('aviso', 'Atenção', 'A quantidade não pode ser menor ou igual a zero.');
      this.loading = false
      return;
    }

    if (Number(custoAdicional.valor) <= 0) {
      this.toastr.mostrarMensagem('aviso', 'Atenção', 'O Valor não pode ser menor ou igual a zero.');
      this.loading = false
      return;
    }

    this.save(custoAdicional);
  }

  save(custoAdicional) {
    custoAdicional.estimativaId = this.estimativaId;

    this.custoAdicionalService.create(custoAdicional).subscribe(
      result => {
        this.limparForm();
        this.toastr.mostrarMensagem('sucesso', "Informação", "Custo Adicional adicionado com sucesso!");

        result.tb_custo_adicional_tipo = custoAdicional.tb_custo_adicional_tipo;
        this.custosAdicionais.unshift(result);
        this.dataSource = new MatTableDataSource<CustoAdicional>(this.custosAdicionais);

        this.calculaTotal();
      },
      error => {
        this.misc.processError(error, 'Não foi possível adicionar o Custo Adicional.');
      }
    ).add(() => {
      this.loading = false;
    });
  }

  excluir(custoAdicional: CustoAdicional) {
    this.custoAdicionalService.delete(custoAdicional.id).subscribe(
      result => {
        this.toastr.mostrarMensagem('sucesso', "Informação", "Custo Adicional excluído com sucesso!");

        this.custosAdicionais = this.custosAdicionais.filter(item => {
          return item.id !== custoAdicional.id;
        });

        this.dataSource = new MatTableDataSource<CustoAdicional>(this.custosAdicionais);
        this.calculaTotal();
      },
      error => {
        this.misc.processError(error, 'Não foi possível excluir o Custo Adicional.');
      }
    ).add(() => {
      this.loading = false;
    });
  }

  calculaTotal() {
    this.totalValor = +this.custosAdicionais.reduce((acc, curr) => acc + (curr.quantidade * curr.valor), 0).toFixed(2);
  }

  setCustoAdicionalTipo(custoAdicionalTipo: CustoAdicionalTipo) {
    this.loading = false;

    this.basicForm.patchValue({
      tb_custo_adicional_tipo: custoAdicionalTipo,
      idCustoAdicionalTipo: custoAdicionalTipo.id
    });
  }

  displayFn(custoAdicionalTipo: CustoAdicionalTipo): string {
    return custoAdicionalTipo && custoAdicionalTipo.descricao ? custoAdicionalTipo.descricao : '';
  }

  populaFiltroCustosAdicionaisTipo() {
    let subscriptions: any = {};

    subscriptions.custoAdicionalTipo = this.custoAdicionalTipoService.getAllAtivas();

    forkJoin(subscriptions).subscribe({
      next: (result: any) => {
        this.custoAdicionalTipoLista = result.custoAdicionalTipo.items.filter((p: CustoAdicionalTipo) => {
          return p.ativo == true;
        });

        this.custoAdicionalTipoLista.sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
        this.custoAdicionalTipoFiltrados = of(this.custoAdicionalTipoLista.filter(p => true));
        this.custoAdicionalTipoFiltrados = this.filtroDescricao.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      },
      error: error => {
        this.misc.processError(error, 'Não foi possível carregar os dados da tela.');
      }
    });
  }

  private _filter(value: any): CustoAdicionalTipo[] {
    if (typeof value === 'string') {
      this.basicForm.patchValue({
        custoAdicionalTipo: null
      });

      const filterValue = value.toLowerCase();
      return this.custoAdicionalTipoLista.filter(option => option.descricao.toLowerCase().includes(filterValue));
    }
  }

  limparForm() {
    this.basicForm = this.fb.group({
      tb_custo_adicional_tipo: null,
      idCustoAdicionalTipo: null,
      quantidade: null,
      valor: null
    });
  }

  atualizarCustoAdicionalEstimativa(custoAdicional: CustoAdicional = new CustoAdicional()) {
    const dialogRef = this.dialog.open(EditarCustoAdicionalEstimativaDialogComponent, {
      width: '600px',
      panelClass: 'default-dialog-container',
      data: custoAdicional
    });

    dialogRef.afterClosed().subscribe(() => {
      this.carregarTela();
    });
  }
}
